import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GetCashBookApi } from "../../ApiRequests";

export const fetchCashBooks = createAsyncThunk(
  "fetch/CashBook",
  async (params = {}) => {
    try {
      const response = await GetCashBookApi(params);
      if (response.data?.success) {
        return response.data.data.payload;
      }
    } catch (error) {
      console.log(error);
    }
    return null;
  }
);

const CashBookSlice = createSlice({
  name: "cashbook-data",
  initialState: {
    loading: false,
    data: null,
    isError: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCashBooks.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchCashBooks.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchCashBooks.rejected, (state) => {
      state.isError = true;
      state.loading = false;
    });
  },
});

export default CashBookSlice.reducer;
